import { AiOutlineCloseCircle } from "react-icons/ai"
import Modal from "../../common/Modal"
import { useAdmin } from "../../../context/admin"
import { FormEvent, useState } from "react"
import { Blog } from "../../../types/common.types"
import FileInput from "../../common/FileInput"
import GeneralInput from "../../common/GeneralInput"
import AdminService from "../../../services/admin.service"
import jsonToFormData from "../../../utils/jsonToFormData"

export default function EditBlog() {
    const { editBlog, setEditBlog } = useAdmin()
    const [data, setData] = useState<Blog>(editBlog || {} as Blog)
    function onChange(e: React.ChangeEvent<HTMLInputElement>) {
        const name = e.target.name
        const value = e.target.value

        setData(prevData => ({...prevData, [name]: value}))
    }

    async function deleteBlog() {
        try {
            if (!editBlog?.id) return
            await AdminService.deleteBlog(editBlog.id)            
            window.location.reload()
        } catch (error) {
            console.log(error)
        }
    }
    async function editExistingBlog(e: FormEvent<HTMLFormElement>) {
        e.preventDefault()
        try {
            if (!editBlog?.id) return
            const newData = {
                blog_id: editBlog.id, 
                title: data.title,
                title_es: data.title_es,
                title_pt: data.title_pt,
                description: data.description,
                description_es: data.description_es,
                description_pt: data.description_pt,
                overview: data.overview,
                overview_es: data.overview_es,
                overview_pt: data.overview_pt,
                cover: data.cover
            }
            const formData = jsonToFormData(newData)
            await AdminService.editBlog(formData)            
            window.location.reload()
        } catch (error) {
            console.log(error)
        }
    }
    return (
        <Modal onSubmit={editExistingBlog}>
            <div className="close" title="close"
            onClick={() => setEditBlog(undefined)}
            >
                <AiOutlineCloseCircle/>
            </div>
            <h1>Edit Blog</h1>
            <div className="input-container">
                <GeneralInput
                label="Title (en)"
                name="title"
                value={data.title}
                onChange={onChange}
                />
                <GeneralInput
                label="Title (es)"
                name="title_es"
                value={data.title_es}
                onChange={onChange}
                />
                <GeneralInput
                label="Title (pt)"
                name="title_pt"
                value={data.title_pt}
                onChange={onChange}
                />
            </div>
            <div className="input-container">
                <GeneralInput
                label="Overview (en)"
                name="overview"
                value={data.overview}
                onChange={onChange}
                />
                <GeneralInput
                label="Overview (es)"
                name="overview_es"
                value={data.overview_es}
                onChange={onChange}
                />
                <GeneralInput
                label="Overview (pt)"
                name="overview_pt"
                value={data.overview_pt}
                onChange={onChange}
                />
                
            </div>
            <div className="input-container">
                <GeneralInput
                label="Description (en)"
                name="description"
                value={data.description}
                onChange={onChange}
                />
                <GeneralInput
                label="Description (es)"
                name="description_es"
                value={data.description_es}
                onChange={onChange}
                />
                <GeneralInput
                label="Description (pt)"
                name="description_pt"
                value={data.description_pt}
                onChange={onChange}
                />
            </div>
            <div className="input-container">
                <FileInput
                    value={data.cover}
                    style={{height: '100px'}}
                    label="Cover"
                    accept=".png, .jpg, .jpeg, .heic"
                    onChange={(newFile: File) => setData(prevData => ({...prevData, cover: newFile}))}
                    deleteFile={() => setData(prevData => {
                        const { cover, ...rest } = prevData; // Destructure to exclude 'photo'
                        return rest as Blog; // Return the rest of the properties without 'photo'
                    })}
                    />
            </div>
            <div className="actions">
                <button>
                    Edit
                </button>
                <button type="button" 
                onClick={deleteBlog}
                style={{backgroundColor: 'red', border: 'none', color: 'white'}}>
                    Delete
                </button>
            </div>
        </Modal>
    )
}